<template>
	<div id="direction-arrows">

   <div v-if="$props.sidebar" :class="$props.sidebar"><router-link to="/"><font-awesome-icon :icon="'chevron-'+$props.sidebar" /><p>Home</p></router-link>
     </div>

   <div v-if="parseInt($props.position) < parseInt($props.count) || parseInt($props.position) === 1" class="bottom-arrows"><router-link :to="getPath('next','url')"><font-awesome-icon icon="chevron-down" /><p>{{getPath('next','name')}}</p></router-link></div>

   <div v-if="parseInt($props.position) > 1 && parseInt($props.position) <= parseInt($props.count)" class="top-arrows"><router-link :to="getPath('prev','url')"><font-awesome-icon icon="chevron-up" /><p>{{getPath('prev','name')}}</p></router-link></div>
  </div>
</template>

<script>
	// @ is an alias to /src
  import { faUserSecret } from '@fortawesome/free-regular-svg-icons'

	export default {
		name: 'DirectionArrows',
		components: {
    },
    props:['position','sidebar','count','name'],
		data:()=>({
		}),
		methods: {
      getPath(order,type) {
        let routes = this.$router.options.routes
        let propsSidebar = this.$props.sidebar
        let propsPosition = this.$props.position
        let next;
        let prev;
        routes.forEach(function(el){

          if( el.props && el.props.sidebar && el.props.position){
            if(el.props.sidebar===propsSidebar && parseInt(el.props.position) === parseInt(propsPosition)+1){
              next = el;

            }
            if(el.props.sidebar===propsSidebar && parseInt(el.props.position) === parseInt(propsPosition)-1){

              prev = el;
            }
          }
        })

        if(type==='url'){

          if(order==='prev'){
            return prev.path
          }else{
            return next.path
          }
        }else{
          if(order==='prev'){
            return prev.name
          }else{
            return next.name
          }
        }

      }
		},


  }
</script>
<style>
	#direction-arrows{
    position: absolute;
    height: 90%;
    width: 100vw;
    top:50px;
    left:0;
    z-index: 0;
  }
  .left{
    position: absolute;
    top:calc(50% - 10px);
    height: 20px;
    left:50px;
    font-weight: bold;
    font-size: 2em;
    display: inline-flex;
  }
  .left p,right p {
    font-size: 0.5em;
    margin-left:10px;
  }
  .left a{
    display: flex;
    align-items: center;
  }
  .right{
    position: absolute;
    top:calc(50% - 10px);
    height: 20px;
    right:50px;
    font-weight: bold;
    font-size: 2em;
  }
  .right p{
    font-size: 0.5em;
    margin-right:10px;

  }
  .right a{
    flex-direction: row-reverse;
    display: flex;
    align-items: center;

  }

  .bottom-arrows{
    position: absolute;
    bottom:20px;
    height: 20px;
    width: 20px;
    left:calc(50% - 10px);
    font-weight: bold;
    font-size: 2em;
  }
  .bottom-arrows a,.top-arrows a{
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
  }
  .top-arrows{
    position: absolute;
    top:40px;
    height: 20px;
    width: 20px;
    left:calc(50% - 10px);
    font-weight: bold;
    font-size: 2em;
  }
  .bottom-arrows a{
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
  } .top-arrows a{
      display: flex;
      flex-direction: column;
      align-items: center;
    } .bottom-arrows p,.top-arrows p{
        margin:0;
        font-size:0.7em;
              display: inline-flex;
    white-space: nowrap;
      }

</style>
